import { AuthUserPermission, UserId } from '@cibo/core'
import { useLandManagement } from '@cibo/landmanager'
import { Can, useWindowTitle } from '@cibo/profile'
import { ClickableCard, Markdown } from '@cibo/ui'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import GestureRoundedIcon from '@mui/icons-material/GestureRounded'
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded'
import { Box, CardContent, Container, Grid, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const AddFields = ({
  paths: { draw, upload },
  userId,
}: {
  paths: {
    draw: string
    upload: string
  }
  userId?: UserId
}) => {
  const { t } = useTranslation('pages/Fields/Add')
  useWindowTitle(t('windowTitle'))
  const { openImportFieldAlyticsDialog } = useLandManagement()

  return (
    <Container>
      <Stack spacing={4} paddingY={4}>
        <Stack alignItems="center" spacing={2}>
          <Can
            useAny={[AuthUserPermission.FIELDALYTICS_IMPORT_REQUEST]}
            fallback={<Typography variant="h4">{t('title')}</Typography>}
          >
            <Typography variant="h4">{t('title', { context: 'fieldalytics' })}</Typography>
          </Can>
          <div style={{ maxWidth: 450 }}>
            <Markdown>{t('instructions_md')}</Markdown>
          </div>
        </Stack>

        <Box>
          <Grid justifyContent="center" spacing={{ xs: 4, md: 8 }} container>
            <Grid xs={12} md={6} lg={4} sx={{ alignSelf: 'stretch', display: 'flex' }} item>
              <ClickableCard LinkComponent={Link} to={draw} sx={{ flex: 1 }}>
                <CardContent>
                  <Stack alignItems="center" spacing={2} sx={{ paddingInline: 4 }}>
                    <GestureRoundedIcon color="secondary" sx={{ fontSize: 96 }} />
                    <Typography variant="h6">{t('draw')}</Typography>
                    <Typography color="text.secondary">{t('drawDetails')}</Typography>
                  </Stack>
                </CardContent>
              </ClickableCard>
            </Grid>
            <Grid xs={12} md={6} lg={4} sx={{ alignSelf: 'stretch', display: 'flex' }} item>
              <ClickableCard LinkComponent={Link} to={upload} sx={{ flex: 1 }}>
                <CardContent>
                  <Stack alignItems="center" spacing={2} sx={{ paddingInline: 4 }}>
                    <UploadFileRoundedIcon color="secondary" sx={{ fontSize: 96 }} />
                    <Typography variant="h6">{t('upload')}</Typography>
                    <Typography color="text.secondary">{t('uploadDetails')}</Typography>
                  </Stack>
                </CardContent>
              </ClickableCard>
            </Grid>

            <Can useAny={[AuthUserPermission.FIELDALYTICS_IMPORT_REQUEST]}>
              <Grid xs={12} md={6} lg={4} sx={{ alignSelf: 'stretch', display: 'flex' }} item>
                <ClickableCard
                  LinkComponent={Link}
                  onClick={() => openImportFieldAlyticsDialog()}
                  sx={{ flex: 1 }}
                >
                  <CardContent>
                    <Stack alignItems="center" spacing={2} sx={{ paddingInline: 4 }}>
                      <CloudUploadIcon color="secondary" sx={{ fontSize: 96 }} />
                      <Typography variant="h6">{t('fieldAlyticsImport')}</Typography>
                      <Typography color="text.secondary">{t('fieldAlyticsDetails')}</Typography>
                    </Stack>
                  </CardContent>
                </ClickableCard>
              </Grid>
            </Can>
          </Grid>
        </Box>
      </Stack>
    </Container>
  )
}
